import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

import { Title4 } from '../title/title'
import { ButtonPrimary } from '../button/button'
import {
  LOCALE_OUT_OF_STOCK,
  LOCALE_PRICE_TAXES_ADVICE,
} from '../../templates/wine.locale'
import styles from './wine.module.css'

const Wine = (props) => {
  const { bodega, path, nombre, uva, precio, stock } = props?.wine?.frontmatter

  const botella = props?.wine?.frontmatter?.imagen
    ? props?.wine?.frontmatter?.imagen?.childImageSharp?.fixed
    : null

  const goToBuy = () => {
    window.location.href = '/compra'
  }

  return (
    <article className={styles.wineTab}>
      {botella && (
        <Img
          className={styles.image}
          title={nombre}
          fixed={botella}
          alt={nombre}
        />
      )}
      <section className={styles.wineInfo}>
        <header className={styles.wineName}>
          <Title4>
            <Link to={path}>{nombre}</Link>
          </Title4>
        </header>
        <div className={styles.winePrice}>
          <span className={styles.winePriceValue}>{precio}</span>
          <span className={styles.winePriceTaxes}>
            {LOCALE_PRICE_TAXES_ADVICE}
          </span>
        </div>
        <div className={styles.wineCellar}>Bodegas {bodega}</div>
        <div className={styles.wineGrape}>{uva}</div>
        {stock > 0 && (
          <div className={styles.buy}>
            <ButtonPrimary
              label="COMPRA"
              type={'outline'}
              size={'small'}
              onClick={goToBuy}
            />
          </div>
        )}
        {stock === 0 && (
          <p className={styles.outOfStock}>{LOCALE_OUT_OF_STOCK}</p>
        )}
      </section>
    </article>
  )
}

export default Wine
